import { useState } from "react";
import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";

function SearchInput({ q, page }) {
  const [query, setQuery] = useState(q);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (query.trim() !== "") {
      Scrivito.navigateTo(page, { q: query });
    }
  };

  return (
    <form method="post" onSubmit={(e) => handleSubmit(e)}>
      <div className="input-group">
        <input
          name="q"
          className="form-control form-control-search"
          placeholder={I18n.t("searchFor")}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button className="btn bg-blue" type="submit">
          {I18n.t("General btn search")}
        </button>
      </div>
    </form>
  );
}

export default Scrivito.connect(SearchInput);
